import { Component, ContainerSpecification, createSprite, SpriteSpecification } from '@1x2network/pixi_assets'
import { Container, Sprite } from 'pixi.js'

/**
 * Reel frame sprite for the reel set
 * @author Adam Drake - <adam.drake@1x2network.com>
 * @version 1.0.0
 */
export class ReelFrame extends Component<ReelFrameSpec> {
    private sprite: Sprite
    constructor(spec: string | ReelFrameSpec, parent: Container) {
        super({ parent: parent, spec })
        this.sprite = createSprite({ spec: this.specification.sprite, parent: this })
    }
}

export interface ReelFrameSpec extends ContainerSpecification {
    sprite: SpriteSpecification
}
